export const KEY_STATUS = 'status';
export const KEY_MESSAGE = 'message';
export const KEY_OBJ = 'obj';

export const CODE_SUCCESS = 200;
export const CODE_ERROR   = 300;
export const CODE_TIMEOUT = 301;

export const JY_WEBSOCKET = 'JY_WEBSOCKET';

export const JY_BACKURL = 'JY_BACKURL';
export const JY_BACKURL_CLEAR = 'JY_BACKURL_CLEAR';

export const JY_TOKEN_GET = 'JY_TOKEN_GET';
export const JY_SETTINGVUE_SET = 'JY_SETTINGVUE_SET';

export const JY_LOGIN = 'JY_LOGIN';
export const JY_LOGIN_TOKEN = 'JY_LOGIN_TOKEN';
export const JY_LOGOUT = 'JY_LOGOUT';
export const JY_LOGIN_CHECK = 'JY_LOGIN_CHECK';
export const JY_LOAD_PERMISSIONS = 'JY_LOAD_PERMISSIONS';

export const JY_LOGIN_MEMBER = 'JY_LOGIN_MEMBER';
export const MEMBER_ADDRESS = 'MEMBER_ADDRESS';

/* 基础信息 */
export const BASE_LOAD = {
  baseLoading: 'baseLoading',
  xiaoquList: 'xiaoquList',
  xiaoquMap: 'xiaoquMap',
  sexList: 'sexList',
  sexMap: 'sexMap',
  ccList: 'ccList',
  xjList: 'xjList',
  xjMap: 'xjMap',
  xjStatus: 'xjStatus',
  preconditionList: 'preconditionList', // 报名前置条件
  sourceMap: 'sourceMap',
  cluestatusMap: 'cluestatusMap',
  visitstatusMap: 'visitstatusMap',
  visittypeMap: 'visittypeMap',
  idcardtype: 'idcardtype',
  bodystate: 'bodystate',
  zyList: 'zyList',
  yxList: 'yxList',
  kcList: 'kcList',
  xlMap: 'xlMap',
  zslsList: 'zslsList',
  njList: 'njList',
  bfeeList: 'bfeeList',
  feetagList: 'feetagList',
  feetagList2: 'feetagList2',
  paymethodMap: 'paymethodMap',
  exportList: 'exportList',
  sealtypeList: 'sealtypeList',
  contracttypeList: 'contracttypeList',
  contractstateList: 'contractstateList',
  goodscateList: 'goodscateList',
  goodsunitList: 'goodsunitList',
  goodsbrandList: 'goodsbrandList',
  jilucateList: 'jilucateList',
  huiyishicateList: 'huiyishicateList',
  huiyishiroomList: 'huiyishiroomList',
  mzList: 'mzList',
  zzmmList: 'zzmmList',
  pxitemList: 'pxitemList', // 培训项目
  pxitemTree: 'pxitemTree', // 培训项目
  empList: 'empList', // 员工列表
  departList: 'departList', // 部门信息
  newscateList: 'newscateList', // 新闻类别
  scoreterm: 'scoreterm', // 成绩【考次】
  scorekstype: 'scorekstype', // 成绩【考次】
  mapareaList: 'mapareaList', // 区域[校区]类别
  kpcateList: 'kpcateList', // 科普类别
}

// 各种状态
export const STATUS = {
  statusLoading: 'statusLoading',
  hjType: 'hjType',
  xjFields: 'xjFields',
  wxStatus: 'wxStatus',
  preconditionCate: 'preconditionCate',
  feeStatus: 'feeStatus',
  rollChangeStatus: 'rollChangeStatus',
  rollOutStatus: 'rollOutStatus',
  exportfields: 'exportfields',
  sealStatus: 'sealStatus',
  contractSecret: 'contractSecret',
  contractFundflow: 'contractFundflow',
  contractIdentity: 'contractIdentity',
  check: 'check',
  logstype: 'logstype',
  orderStatus: 'orderStatus',
  sitetype: 'sitetype',
  qingkuancate: 'qingkuancate',
  tichengstatus: 'tichengstatus'
};

export const MEMBER = {
  reloadList: 'member_reloadList' // 会员信息
};

export const OTHER = {
  reloadZy: 'other_reloadZy', // 专业信息
  reloadYx: 'other_reloadYx', // 院校信息
  reloadKc: 'other_reloadKc', // 课程信息
  reloadFee: 'other_reloadFee', // 收费项目
  reloadFeetag: 'other_reloadFeetag', // 缴费标签
  reloadFeeout: 'other_reloadFeeout', // 交款单
  reloadSfbz: 'other_reloadSfbz', // 收费标准
  reloadBase: 'other_reloadBase', // 基础信息
  reloadStu: 'other_reloadStu', // 学生信息
  reloadRoll: 'other_reloadRoll', // 学籍信息
  reloadClass: 'other_reloadClass', // 班级信息
  reloadClassRoll: 'other_reloadClassRoll', // 班级学生信息
  reloadRollChange: 'other_reloadRollChange', // 学籍更改信息
  reloadScore: 'other_reloadScore', // 成绩信息
  reloadExport: 'other_reloadExport',
  reloadPxinfo: 'other_reloadPxinfo', // 印章类型
  reloadSealtype: 'other_reloadSealtype', // 印章类型
  reloadSeal: 'other_reloadSeal', // 用章信息
  reloadContract: 'other_reloadContract', // 合同信息
  reloadGoods: 'other_reloadGoods', // 办公用品
  reloadJilu: 'other_reloadJilu', // 违纪罚款
  reloadHuiyishi: 'other_reloadHuiyishi', // 会议室借用登记
  reloadNotify: 'other_reloadNotify', // 提醒信息
  reloadNotice: 'other_reloadNotice', // 公告信息
  reloadNews: 'other_reloadNews', // 新闻信息
  reloadInfo: 'other_reloadInfo', // 活动信息
  reloadPoint: 'other_reloadPoint', // 活动信息
  reloadKp: 'other_reloadKp', // 科普信息
  reloadOrder: 'other_reloadOrder', // 订单信息
  reloadWebUser: 'other_reloadWebUser', // [我的] 页面刷新
  reloadAddress: 'other_reloadAddress', // [我的] 地址刷新
  reloadSite: 'other_reloadSite', // 网站内容
  reloadDepart: 'other_reloadDepart', // 部门信息
  reloadEmp: 'other_reloadEmp', // 员工信息
  reloadComment: 'other_reloadComment', // 评论信息
  reloadWeb: 'other_reloadWeb', // 前端
};
